import { render, staticRenderFns } from "./TitleContainerComponent.vue?vue&type=template&id=76225e64&"
import script from "./TitleContainerComponent.vue?vue&type=script&lang=js&"
export * from "./TitleContainerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VChipGroup,VDivider})
